import React, { useState } from "react";
import { Info } from "lucide-react";
import { scoreColor } from "../../lib/format";

// Clean horizontal bar with plain-English explanation
export default function ScoreBar({ value = 0, dimension, testId, delay = 0 }) {
  const v = Math.max(0, Math.min(100, value));
  const color = scoreColor(v);
  const [showHelp, setShowHelp] = useState(false);

  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-ink-border-subtle bg-ink-surface/60 p-5 lift fade-up"
      style={{ animationDelay: `${delay}s` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <h4 className="text-white text-[15px] font-medium">{dimension.label}</h4>
            <button
              onMouseEnter={() => setShowHelp(true)}
              onMouseLeave={() => setShowHelp(false)}
              onFocus={() => setShowHelp(true)}
              onBlur={() => setShowHelp(false)}
              className="text-zinc-600 hover:text-zinc-400 transition-colors relative"
              aria-label={`What does ${dimension.label} mean?`}
            >
              <Info size={12} />
              {showHelp && (
                <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-10 w-56 px-3 py-2 rounded-lg bg-black border border-ink-border text-xs text-zinc-300 leading-relaxed shadow-xl whitespace-normal text-left">
                  {dimension.helper}
                </span>
              )}
            </button>
          </div>
          <p className="mt-1 text-xs text-zinc-500 leading-snug">{dimension.short}</p>
        </div>
        <div className="text-right shrink-0">
          <div className="text-2xl font-semibold tabular-nums" style={{ color }}>{v}</div>
          <div className="text-[10px] text-zinc-600 -mt-0.5">/ 100</div>
        </div>
      </div>

      {/* Bar */}
      <div className="mt-4 relative h-1.5 rounded-full bg-ink-soft overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${v}%`, backgroundColor: color }}
        />
      </div>

      <div className="mt-2 text-xs" style={{ color }}>
        {dimension.scale(v)}
      </div>
    </div>
  );
}
